import _merge from 'lodash/merge';
import _keys from 'lodash/keys';
import _cloneDeep from 'lodash/cloneDeep';
import _keyBy from 'lodash/keyBy';
import _pick from 'lodash/pick';
import _reduce from 'lodash/reduce';
import _split from 'lodash/split';
import _tail from 'lodash/tail';
import _head from 'lodash/head';

import EventBus from '@/event-bus';
import Shop from '@/shop';

var Ecommerce = function() {
  var self = this;
  var _config = Shop.config.get([
    'currency_code',
    'new_ya_metrika'
  ]);

  // Меняем RUR на RUB, как того хочет Яндекс https://yandex.ru/support/metrica/ecommerce/data.html
  _config.currency_code = _config.currency_code === 'RUR' ? 'RUB' : _config.currency_code;

  if (!_config.new_ya_metrika) {
    return false;
  }

  // Шаблон для событий
  self.ecommerce = { ecommerce: { currencyCode: _config.currency_code } };

  self._savedOrderLines = [];

  window.dataLayer = window.dataLayer || [];
  self.layer = window.dataLayer;
  self._addProductEvent();
  self._deleteProductEvent();

  //console.debug('Ecommerce: constructor: self: ', self);
  return self;
};

/**
 * @description
 * Вещаем слушателя на добавление товара в корзину
 *
 * @return {void}
 */
Ecommerce.prototype._addProductEvent = function() {
  var self = this;

  EventBus.subscribe('add_items:insales:cart', function(eventData) {
    self.send(self._getAddedProducts(eventData), 'add');
  });

  EventBus.subscribe('add_checkout:insales:cart', function(eventData) {
    self.send(self._getAddedProducts(eventData), 'add');
  });
};

/**
 * @description
 * Вещаем слушателя на удаление товара из корзины
 *
 * @return {void}
 */
Ecommerce.prototype._deleteProductEvent = function() {
  var self = this;

  EventBus.subscribe('before:insales:cart', function(eventData) {
    if (eventData.action.method == 'delete_items') {
      self._saveOrder();
    }
  });

  EventBus.subscribe('delete_items:insales:cart', function(eventData) {
    self.send(self._getDeletedProducts(eventData), 'remove');
  });
};

/**
 * @description
 * Отправка инфы в метрику
 *
 * @param {Object} sendData - данные на отправку
 * @param {String} method - что мы делаем
 *
 * @return {void}
 */
Ecommerce.prototype.send = function(sendData, method) {
  var self = this;
  var _ecommerce = _merge({}, self.ecommerce);

  _ecommerce.ecommerce[method] = { products: sendData };

  self.layer.push(_ecommerce);
  //console.log('Ecommerce: send: _ecommerce: ', _ecommerce);
};

/**
 * @private
 *
 * @description
 * Собираем информацию по товарам
 *
 * @param {Object} products - объект с товарами для отправки
 *
 * @return {Array} - собранная информация для Яндекса
 */
Ecommerce.prototype._getAddedProducts = function(products) {
  var self = this;
  var _addedItems = products.action.items;
  var _products = [];

  const clonedLines = _cloneDeep(products.order_lines);
  const keyedLines = _keyBy(clonedLines, 'id');
  const pickedLines = _pick(keyedLines, _keys(_addedItems));
  _products = _reduce(pickedLines, (acc, line) => {
    acc.push(self._addedProduct(line, _addedItems));

    return acc;
  }, []);

  //console.debug('Ecommerce: _getAddedProducts: _products: ', _products);

  return _products;
};

/**
 * @description
 * Вытаскиваем название варианта. По-умолчанию оно завернуто в `()`
 *
 * @param {Object} line - информация о товаре
 *
 * @return {String|Null} - название варианта
 */
Ecommerce.prototype._getVariantTitle = function(line) {
  var _title = null;

  if (line.title != line.product.title) {
    const titleParts = _split(line.title, '(');
    const tailPart = _tail(titleParts);
    const splitParts = _split(_head(tailPart), ')');
    _title = _head(splitParts);
  }

  return _title;
};

/**
 * @description
 * Готовим запись о добавленом товаре
 *
 * @param {Object} line - запись о товаре
 * @param {Object} addedItems - информация о добавленых товарах
 *
 * @return {Object} - готовая запись
 */
Ecommerce.prototype._addedProduct = function(line, addedItems) {
  var self = this;
  var _variant = self._getVariantTitle(line);
  var _product = {
    id: line.product.id,
    name: line.product.title,
    quantity: addedItems[line.id],
    price: line.sale_price,
  };

  if (_variant) {
    _product.variant = _variant;
  }

  return _product;
};

/**
 * @description
 * Сохраняем корзину перед удалением товаров
 *
 * @return {void}
 */
Ecommerce.prototype._saveOrder = function() {
  var self = this;

  self._savedOrderLines = _cloneDeep(InsalesCommonCart.order.get()).order_lines;
  //console.debug('Ecommerce: _saveOrder: self._savedOrderLines: ', self._savedOrderLines);
};

/**
 * @description
 * Получаем информацию по удаленым товарам
 *
 * @param {Object} eventData - Информация от шины событий
 *
 * @return {Object} - информауия об удаленном товаре
 */
Ecommerce.prototype._getDeletedProducts = function(eventData) {
  var self = this;
  var _deletedItems = eventData.action.items;
  var _products = [];

  _products = _reduce(
    _keyBy(self._savedOrderLines, 'id'),
    (result, line, id) => {
      if (_deletedItems.includes(id)) {
        result.push(self._deletedProduct(line, _deletedItems));
      }

      return result;
    },
    []
  );

  return _products;
};

/**
 * @description
 * Получаем информацию по удаленому товару
 *
 * @param {Object} line -
 * @param {Object} deletedItems -
 *
 * @return {Object} -
 */
Ecommerce.prototype._deletedProduct = function(line) {
  var self = this;
  var _variant = self._getVariantTitle(line);
  var _product = {};

  _product = {
    id: line.product.id,
    name: line.product.title,
  };

  if (_variant) {
    _product.variant = _variant;
  }

  return _product;
};

export default Ecommerce;
